<template>
    <layout-page-info :title="title">
        <div v-html="content"></div>

        <template slot="btn">
            <v-btn @click="$emit('success')" large color="success">Приступить</v-btn>
        </template>
    </layout-page-info>
</template>

<script>
    import LayoutPageInfo from '@/components/layouts/page-info'

    export default {
        components: {
            LayoutPageInfo
        },
        props: {
            title: String,
            content: String
        }
    }
</script>
